<template>
    <div class="news">
        <TopNavBar :navtitle="ChannelsName"></TopNavBar>
        <div class="newslist" v-if="NewsList&&NewsList.length>0">
            <ul>
                <li v-for="(NewsItem,index) in NewsList" :key="index">
                    <router-link @click.native="goToUrl(NewsItem)" :to="{ path: $route.fullPath }">
                        <h1>{{NewsItem.Title}}</h1>
                        <p>{{NewsItem.IndexInfo}}</p>
                        <div class="newsimg" v-if="NewsItem.PicPath&&NewsItem.PicPath!=''">
                            <img :src="imgurl" alt="" v-for="(imgurl,index) in NewsItem.PicPath.split(',')" :key="index">
                        </div>
                    </router-link>
                    <div class="newsnote">
                        <label v-if="NewsItem.LinkUrl && NewsItem.LinkUrl != ''"><em class="iconfont .icon-fenxiang"></em>转载</label>
                        <label v-else><em class="iconfont icon-chakan"></em>{{NewsItem.ClickNum}}</label>
                        <span>
                            <em class="iconfont icon-shijian1"></em>{{NewsItem.UpTime.split(' ')[0]}}
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <van-empty v-else description="暂无数据..." />
    </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue';
import { GetNewsList } from '@/api/public';
export default {
    components: {
        TopNavBar
    },
    data () {
        return {
            NewsList: [],
            ChannelsName: '',
        }
    },
    created () {
        if (this.$route.query.CID != undefined && this.$route.query.CID > 0) {
            GetNewsList({ CID: this.$route.query.CID ,OrderByStr:this.$route.query.CID==13?"Random":"",PageSize:100}).then((result) => {
                this.NewsList = result.listData;
                this.showload = false;
                if(result.OtherMsg)
                this.ChannelsName = result.OtherMsg.ChannelsName;

            }).catch((err) => {
                this.$router.push('/404');
            });
        }
        else {
            this.$router.push('/404');
        }
    },
    methods: {
        goToUrl (item) {
            if (item.LinkUrl && item.LinkUrl != '') {
                window.location.href = item.LinkUrl
            } else {
                this.$router.push({ path: `/NewsDetail?News_ID=${item.NewsID}` })
            }
        }
    }
}
</script>

<style>
</style>